export default "__VITE_ASSET__KbjiWQ64__"